import { Box, Typography } from "@mui/material";
import { useTagDisplayName } from "catalog/hooks/useTagDisplayMappings";
import { Tag } from "~/types/interfaces/catalogResponse";

interface EditConfig {
  resources: {
    urn: string;
    subResource?: string;
    subResourceType?: string;
  }[];
  refreshResource: () => void;
}

interface EntityTagProps {
  tag: Pick<Tag, "tagFQN"> & Partial<Tag>;
  count?: number;
  filterable?: boolean;
  editConfig?: EditConfig;
}

export const TagLabel = (props: { tagFQN: string }) => {
  const displayName = useTagDisplayName(props.tagFQN);
  return (
    <Typography fontSize={13} color="inherit" lineHeight={1}>
      {displayName}
    </Typography>
  );
};

const EntityTag = ({ tag }: EntityTagProps) => {
  return (
    <Box display="flex" gap={0.5} alignItems="center" whiteSpace="nowrap">
      <TagLabel tagFQN={tag.tagFQN} />
    </Box>
  );
};

export default EntityTag;
